import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Enhanced scroll-to-top hook that prevents animation conflicts
 * Instantly scrolls to top and manages animation states properly
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();
  const isNavigatingRef = useRef(false);

  useEffect(() => {
    // Set navigation flag to prevent animations during scroll
    isNavigatingRef.current = true;

    // Instantly scroll to top without smooth behavior
    window.scrollTo(0, 0);

    // Small delay to ensure DOM is settled, then re-enable animations
    const timer = setTimeout(() => {
      isNavigatingRef.current = false;
    }, 50);

    return () => {
      clearTimeout(timer);
    };
  }, [pathname]);

  // Return navigation state for components that need it
  return { isNavigating: isNavigatingRef.current };
};

export default useScrollToTop;
